import { Gift } from "lucide-react";
import { fmtEUR } from "@/lib/format";

const th = "font-semibold px-4 py-3";

export function OmaggiCausali({ rows }) {
  const causali = {};
  rows.forEach((r) => {
    const c = (causali[r.causale] ||= { causale: r.causale, qty: 0, valore: 0, marche: [] });
    c.qty += r.qty; c.valore += r.valore; c.marche.push(r);
  });
  const list = Object.values(causali).sort((a, b) => b.valore - a.valore);
  const tot = list.reduce((s, c) => s + c.valore, 0);
  if (!list.length) return <div className="card-soft p-8 text-sm text-[#756B64]" data-testid="omaggi-causale-empty">Nessun omaggio nel periodo selezionato.</div>;
  return (
    <div className="space-y-5" data-testid="omaggi-causale-view">
      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-3">
        {list.map((c, i) => (
          <div key={c.causale} className="card-soft px-5 py-4" data-testid={`omaggi-causale-card-${i}`}>
            <div className="flex items-center gap-1.5 text-[11px] uppercase tracking-wider text-[#756B64] font-semibold"><Gift className="h-3 w-3" />{c.causale}</div>
            <div className="text-xl font-semibold tabular mt-1">{fmtEUR(c.valore)}</div>
            <div className="text-xs text-[#756B64] mt-0.5">{c.qty} pz · {tot ? Math.round((c.valore / tot) * 100) : 0}% degli omaggi</div>
            <div className="h-1.5 rounded-full bg-[#F4EFEA] mt-3 overflow-hidden"><div className="h-full bg-[#CBA368]" style={{ width: `${tot ? (c.valore / tot) * 100 : 0}%` }} /></div>
          </div>
        ))}
      </div>
      <div className="card-soft overflow-x-auto" data-testid="omaggi-causale-table">
        <table className="w-full text-sm min-w-[640px]">
          <thead className="bg-[#FAF7F5] text-[11px] uppercase tracking-wider text-[#756B64]">
            <tr><th className={`${th} text-left`}>Causale</th><th className={`${th} text-left`}>Marca</th><th className={`${th} text-right`}>Pezzi</th><th className={`${th} text-right`}>Valore (costo medio)</th></tr>
          </thead>
          <tbody className="divide-y divide-[#EAE3DC]">
            {list.flatMap((c) => c.marche.map((r, j) => (
              <tr key={c.causale + r.marca} className="hover:bg-[#FAF7F5]" data-testid={`omaggi-causale-row-${c.causale}-${j}`}>
                <td className="px-4 py-2.5 font-medium">{j === 0 ? c.causale : ""}</td>
                <td className="px-4 py-2.5">{r.marca}</td>
                <td className="px-4 py-2.5 text-right tabular">{r.qty}</td>
                <td className="px-4 py-2.5 text-right tabular">{fmtEUR(r.valore)}</td>
              </tr>
            )))}
            <tr className="bg-[#FAF7F5] font-semibold" data-testid="omaggi-causale-totale"><td className="px-4 py-3" colSpan={2}>Totale omaggi</td><td className="px-4 py-3 text-right tabular">{list.reduce((s, c) => s + c.qty, 0)}</td><td className="px-4 py-3 text-right tabular">{fmtEUR(tot)}</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
